var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _rect7, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 293,
    viewBox: "0 0 465 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 87L6.10352e-05 274L130 274L130 189.695L130 87L6.10352e-05 87Z",
    fill: "url(#paint0_linear_18599_598)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 100,
    width: 12,
    height: 79,
    rx: 6,
    transform: "rotate(90 79 100)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 130,
    width: 12,
    height: 57,
    rx: 6,
    transform: "rotate(90 57 130)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 160,
    width: 12,
    height: 115,
    rx: 6,
    transform: "rotate(90 115 160)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.0001,
    y: 190,
    width: 12,
    height: 46,
    rx: 6,
    transform: "rotate(90 46.0001 190)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85.0001,
    y: 220,
    width: 12,
    height: 85,
    rx: 6,
    transform: "rotate(90 85.0001 220)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 250,
    width: 12,
    height: 71,
    rx: 6,
    transform: "rotate(90 71 250)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127 79C127 75.6863 129.686 73 133 73H373C376.314 73 379 75.6863 379 79V287C379 290.314 376.314 293 373 293H133C129.686 293 127 290.314 127 287V79ZM139 85V281H367V85H139Z",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 66,
    width: 252,
    height: 220,
    rx: 16,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.5 156.5C157.5 155.948 157.724 155.5 158 155.5H182C182.276 155.5 182.5 155.948 182.5 156.5C182.5 157.052 182.276 157.5 182 157.5H158C157.724 157.5 157.5 157.052 157.5 156.5Z",
    fill: "#FF849A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.5 204.5C157.5 203.948 157.724 203.5 158 203.5H174C174.276 203.5 174.5 203.948 174.5 204.5C174.5 205.052 174.276 205.5 174 205.5H158C157.724 205.5 157.5 205.052 157.5 204.5Z",
    fill: "#FF849A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.5 180.5C157.5 179.948 157.724 179.5 158 179.5H166C166.276 179.5 166.5 179.948 166.5 180.5C166.5 181.052 166.276 181.5 166 181.5H158C157.724 181.5 157.5 181.052 157.5 180.5Z",
    fill: "#FF849A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.5 228.5C157.5 227.948 157.724 227.5 158 227.5H166C166.276 227.5 166.5 227.948 166.5 228.5C166.5 229.052 166.276 229.5 166 229.5H158C157.724 229.5 157.5 229.052 157.5 228.5Z",
    fill: "#FF849A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.5 252.5C157.5 251.948 157.724 251.5 158 251.5H182C182.276 251.5 182.5 251.948 182.5 252.5C182.5 253.052 182.276 253.5 182 253.5H158C157.724 253.5 157.5 253.052 157.5 252.5Z",
    fill: "#FF849A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.5 156.5C245.5 155.948 245.724 155.5 246 155.5H266C266.276 155.5 266.5 155.948 266.5 156.5C266.5 157.052 266.276 157.5 266 157.5H246C245.724 157.5 245.5 157.052 245.5 156.5Z",
    fill: "#FF849A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.5 180.5C261.5 179.948 261.724 179.5 262 179.5H294C294.276 179.5 294.5 179.948 294.5 180.5C294.5 181.052 294.276 181.5 294 181.5H262C261.724 181.5 261.5 181.052 261.5 180.5Z",
    fill: "#FF849A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.5 204.5C277.5 203.948 277.724 203.5 278 203.5H334C334.276 203.5 334.5 203.948 334.5 204.5C334.5 205.052 334.276 205.5 334 205.5H278C277.724 205.5 277.5 205.052 277.5 204.5Z",
    fill: "#FF849A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.5 228.5C261.5 227.948 261.724 227.5 262 227.5H294C294.276 227.5 294.5 227.948 294.5 228.5C294.5 229.052 294.276 229.5 294 229.5H262C261.724 229.5 261.5 229.052 261.5 228.5Z",
    fill: "#FF849A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.5 252.5C245.5 251.948 245.724 251.5 246 251.5H266C266.276 251.5 266.5 251.948 266.5 252.5C266.5 253.052 266.276 253.5 266 253.5H246C245.724 253.5 245.5 253.052 245.5 252.5Z",
    fill: "#FF849A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214 126C215.105 126 216 126.895 216 128V280C216 281.105 215.105 282 214 282C212.895 282 212 281.105 212 280V128C212 126.895 212.895 126 214 126Z",
    fill: "#999999"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.5 100.5C157.5 99.9477 157.724 99.5 158 99.5H174C174.276 99.5 174.5 99.9477 174.5 100.5C174.5 101.052 174.276 101.5 174 101.5H158C157.724 101.5 157.5 101.052 157.5 100.5Z",
    fill: "#FF849A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 128C124 126.895 124.895 126 126 126H366C367.105 126 368 126.895 368 128C368 129.105 367.105 130 366 130H126C124.895 130 124 129.105 124 128Z",
    fill: "#999999"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 72C120 68.6863 122.686 66 126 66H366C369.314 66 372 68.6863 372 72V280C372 283.314 369.314 286 366 286H126C122.686 286 120 283.314 120 280V72ZM132 78V274H360V78H132Z",
    fill: "#0175EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M377.1 72.4992V49.1992H400.5L377.1 72.4992Z",
    fill: "#FF849A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M459.1 56.8H367C363.7 56.8 361 54.1 361 50.8V6C361 2.7 363.7 0 367 0H459.1C462.4 0 465.1 2.7 465.1 6V50.8C465.1 54.1 462.4 56.8 459.1 56.8Z",
    fill: "#FF849A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M429.2 17.7C429.2 17.4 429.1 17.2 428.9 17L423.2 11.3C422.8 10.9 422.2 10.9 421.8 11.3L412.6 20.5L403.4 11.3C403 10.9 402.4 10.9 402 11.3L396.3 17C396.1 17.2 396 17.4 396 17.7C396 18 396.1 18.2 396.3 18.4L405.5 27.6L396.3 36.8C396.1 37 396 37.2 396 37.5C396 37.8 396.1 38 396.3 38.2L402 43.9C402.4 44.3 403 44.3 403.4 43.9L412.6 34.7L421.8 43.9C422 44.1 422.3 44.2 422.5 44.2C422.7 44.2 423 44.1 423.2 43.9L428.9 38.2C429.1 38 429.2 37.8 429.2 37.5C429.2 37.2 429.1 37 428.9 36.8L419.7 27.6L428.9 18.4C429.1 18.2 429.2 18 429.2 17.7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18599_598",
    x1: 6.68386,
    y1: 209.264,
    x2: 121.721,
    y2: 214.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4449,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.92ecfafe.svg";
export { ForwardRef as ReactComponent };